import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import Avatar from 'flarum/common/components/Avatar';
import Link from 'flarum/common/components/Link';
import stringToColor from 'flarum/common/utils/stringToColor';
import { lookFor, nextTier, t, tierFor, tierName } from './flame';
/** A flame's colour as a CSS custom property, so the stylesheet stays theme-led. */
export function flameStyle(color) {
  return {
    '--flame': color
  };
}

/**
 * The flame after a name: icon and number, in the tier's colour.
 *
 * Reads only what it is handed. It appears beside every post author, so it
 * never fetches anything.
 */
export class FlameBadge extends Component {
  view() {
    const days = this.attrs.days;
    if (!days) return null;
    const look = lookFor(days, this.attrs.user);
    const tier = tierFor(days);
    const label = t('badge_label', {
      count: days,
      tier: tierName(tier)
    }) + (look.occasion ? ` · ${look.occasion}` : '');
    return m("span", {
      className: 'FlameBadge' + (look.glow ? ' FlameBadge--glow' : '') + ' ' + (this.attrs.className || ''),
      style: flameStyle(look.color),
      title: label,
      "aria-label": label,
      role: "img"
    }, m(Icon, {
      name: look.icon
    }), m("span", {
      className: "FlameBadge-count",
      "aria-hidden": "true"
    }, days));
  }
}

/** A bar toward the next tier, with how many days are left. */
export function tierProgress(days) {
  const next = nextTier(days);
  const from = tierFor(days)?.days || 0;
  if (!next) return m("div", {
    className: "FlameProgress is-top"
  }, t('top_tier'));
  const share = Math.min(1, Math.max(0, (days - from) / Math.max(1, next.days - from)));
  return m("div", {
    className: "FlameProgress",
    style: flameStyle(next.color)
  }, m("div", {
    className: "FlameProgress-bar"
  }, m("span", {
    style: {
      width: Math.round(share * 100) + '%'
    }
  })), m("div", {
    className: "FlameProgress-label"
  }, t('days_to_tier', {
    count: next.days - days,
    tier: tierName(next)
  })));
}

/** A small member line: avatar and name, linked to their profile. */
export function miniUser(user) {
  const href = app.route('user', {
    username: user.slug
  });
  // Avatar reads only these three; the board sends a slim user, not a model.
  const stub = {
    avatarUrl: () => user.avatarUrl,
    displayName: () => user.displayName,
    username: () => user.username,
    color: () => '#' + stringToColor(user.displayName)
  };
  return m(Link, {
    className: "FlameUser",
    href: href
  }, m(Avatar, {
    user: stub
  }), m("span", {
    className: "FlameUser-name"
  }, user.displayName));
}
/** The community bonfire: every flame fed today feeds it. */
export function bonfire(fed, b) {
  return m("section", {
    className: "StreaksSide StreaksBonfire"
  }, m("h4", null, t('side.bonfire')), m("div", {
    className: "StreaksBonfire-body"
  }, m("div", {
    className: 'StreaksBonfire-fire is-level-' + Math.min(4, b.level),
    "aria-hidden": "true"
  }, m(Icon, {
    name: "fas fa-fire"
  })), m("div", null, m("strong", {
    className: "StreaksBonfire-count"
  }, fed), m("div", null, t('bonfire.fed', {
    count: fed
  })), m("div", {
    className: "FlameProgress-bar"
  }, m("span", {
    style: {
      width: Math.round(b.progress * 100) + '%'
    }
  })), m("small", null, b.toNext > 0 ? t('bonfire.to_next', {
    count: b.toNext,
    level: b.level + 1
  }) : t('bonfire.max')))));
}
flarum.reg.add('ernestdefoe-cadence', 'common/streak/components', { flameStyle: flameStyle,FlameBadge: FlameBadge,tierProgress: tierProgress,miniUser: miniUser,bonfire: bonfire, });